export default __webpack_public_path__ + "media/images/dividers/right-peaked-tear-e81614089521704f7246d73e7edd145a.svg";